module.exports = __webpack_public_path__ + "img/662-dd774e.png";